ux-iws-teaser-download-tile {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
}

.ux-iws-teaser-download-tile {
    background-color: $color-white;
    cursor: pointer;
    box-shadow: 0 0 22px transparentize($color-black, 0.92);
    width: 100%;

    h3,
    h4,
    h5,
    p,
    ux-tag {
        margin: 0;
    }

    &__inner {
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: stretch;
        flex-flow: row nowrap;
        width: 100%;
        height: 100%;
    }

    &__image {
        box-sizing: border-box;
        display: none;
        align-items: flex-start;
        justify-content: center;
        flex: 0 0 auto;
        width: 130px;
        min-height: 180px;
        height: 100%;
        border: 5px solid $color-white;

        > *,
        img {
            flex: 1 1 auto;
            display: block;
            width: 100%;
            height: auto;
        }

        @media screen and (min-width: 768px) {
            display: flex;
        }
    }

    &__header {
        flex: 0 0 auto;
        margin: 0 0 10px;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
    }

    &__content {
        box-sizing: border-box;
        flex: 1 1 auto;
        padding: 20px 30px;
    }

    &__info {
        font-size: $size-text-small;
        color: $color-gray-text;
        display: inline-block;
    }

    &__title {
        font-size: $size-text-title-bold;
        line-height: 1.3;
        margin: 5px 0;
        max-width: 100%;
        hyphens: auto;
    }

    &__description {
        font-size: var(--ux-text-font-size-normal);
        line-height: var(--ux-text-line-height-normal);
        color: $color-gray-text;
        max-width: 100%;
        hyphens: auto;
    }

    &__actions {
        flex: 0 0 auto;
        align-self: flex-end;
        padding: 0 30px 30px 0;
    }
}

.ux-iws-teaser-download-tile-grid {
    @supports (display: grid) {
        display: grid;
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        grid-template-columns: 1fr;

        @media screen and (min-width: 1200px) {
            grid-template-columns: 1fr 1fr;
        }
    }

    @supports not (display: grid) {
        display: flex;
        flex-flow: row wrap;
        margin: -15px;

        ux-iws-teaser-download-tile {
            flex: 1 0 auto;
            padding: 15px;
        }
    }
}
